// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileAppLayout_root__NF9Iu","withoutNavigation":"MobileAppLayout_withoutNavigation__ngi83"};